<header class="rental__header">
  <img [routerLink]="'/home'" class="rental__header__logo" src="assets/images/logos/sodimac-header.svg" alt="SODIMAC Logo"/>

  <div class="rental__header__session">
    <ng-container *ngIf="(user | async) as u; else login">
      <p class="rental__header__session__user">
        <img src="assets/images/icons/user.svg" class="rental__header__session__user__icon">
        Hola <span class="rental__header__session__user__full-name">{{ u?.fullName }}</span>
      </p>

      <p class="rental__header__session__location">
        <img src="assets/images/icons/location.svg" class="rental__header__session__location__icon">
        {{ u?.country?.option }}
      </p>

      <mat-icon (click)="logOut()" fontIcon="logout" [color]="'primary'" [inline]="true" class="rental__header__session__logout-icon" aria-hidden="false" aria-label="Cerrar sesión"></mat-icon>
    </ng-container>

    <ng-template #login>
<!--      No se requiere un botón para Ingresar, la redirección al logIn de Azure NT es automática-->
<!--      <p (click)="logIn()" class="rental__header__session__user">-->
<!--        <img src="assets/images/icons/user.svg" class="rental__header__session__user__icon">-->
<!--        Ingresar-->
<!--      </p>-->
    </ng-template>
  </div>
</header>
